<template>
  <LangRouterLink
    :to="{ name: 'category', params: { slug: category.slug } }"
    :class="['activity-type__category', color(category.color, 'darker')]"
    :title="category.title"
  >
    <span :class="['activity-type__category-label', color(category.color)]">{{
      category.title
    }}</span>
  </LangRouterLink>
</template>

<script>
import { LangRouterLink } from '@/components/global'
import { color } from '@/helpers'
import { HasCategory } from '@/mixins'

export default {
  name: 'ActivityTypeCategory',
  mixins: [HasCategory],
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
  },
  components: { LangRouterLink },
  computed: {
    category() {
      return this.getCategory(this.categoryId)
    },
  },
  methods: {
    color,
  },
}
</script>
